import { LegacyExportModule } from '../../modules/export/LegacyExportModule/LegacyExportModule.tsx';

export const Tkv2LegacyOrderExportRouteElement = () => <LegacyExportModule />;
